const getBaseUrl = () =>
  (typeof window !== 'undefined' && (window as Window & { __ROSTA_API_URL__?: string }).__ROSTA_API_URL__)
  || import.meta.env.VITE_API_URL
  || 'http://localhost:3200/api/v1';

export const fetchApi = async (path: string, options?: RequestInit) => {
  const token = localStorage.getItem('rosta_token');
  const response = await fetch(`${getBaseUrl()}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      ...options?.headers,
    },
  });
  if (!response.ok) throw new Error(`API error: ${response.status}`);
  const json = await response.json();
  return json.data;
};
